import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import { Button } from "../components/ui/button";
import { ASSET } from "../lib/api";
import { useLang } from "../contexts/LangContext";

export default function BoxCard({ box }) {
  const { add } = useCart();
  const { t, formatPrice } = useLang();
  return (
    <div data-testid={`box-card-${box.id}`} className="group hover-lift bg-card border border-border rounded-sm overflow-hidden">
      <Link to={`/box/${box.id}`} className="block relative aspect-[4/5] overflow-hidden bg-[hsl(var(--muted))]">
        <img src={ASSET(box.image)} alt={box.name} loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute top-3 left-3 chip bg-white/90 text-[hsl(var(--primary))]">
          {box.category}
        </div>
        {box.region && (
          <div className="absolute bottom-3 left-3 text-xs font-semibold text-white uppercase tracking-[0.2em] drop-shadow">{box.region}</div>
        )}
      </Link>
      <div className="p-4 md:p-5">
        <h3 className="editorial-heading text-xl md:text-2xl leading-tight text-foreground">{box.name}</h3>
        <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{box.description}</p>
        <div className="mt-3 flex items-center justify-between">
          <div className="text-lg font-bold text-[hsl(var(--primary))]">{formatPrice(box.price)}</div>
          <Button
            data-testid={`add-to-cart-${box.id}`}
            size="sm"
            onClick={() => add({ product_id: box.id, product_type: "box", name: box.name, image: box.image, unit_price: box.price, quantity: 1, unit: "pz" })}
            className="bg-[hsl(var(--secondary))] text-white hover:bg-[hsl(var(--secondary))]/90 rounded-sm text-xs"
          >
            {t("ui.add_to_cart", "Aggiungi")}
          </Button>
        </div>
      </div>
    </div>
  );
}
